import React, { useState } from 'react';
import styles from './LoginForm.module.scss';

const LoginForm = ({ setPasswordCorrect }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handleLogin = (event) => {
    event.preventDefault();
    if (password === process.env.REACT_APP_PASSWORD) {
      setPasswordCorrect(true);
    } else {
      setError(true);
      setPassword('');
    }
  };

  return (
    <form onSubmit={handleLogin} className={styles.loginForm}>
      <input
        type='password'
        value={password}
        onChange={(e) => { setError(false); setPassword(e.target.value); }}
        placeholder={error ? 'Incorrect password' : 'Enter password'}
        className={error ? styles.inputError : ''}
        required
      />
    </form>
  );
};

export default LoginForm;
